
import { defineComponent, PropType } from 'vue';
import { TileModel } from '@/types/B2BcontentServerContract';
import { blockResolver } from '@/core/component-resolver.service';
import { IBlockLabels, provideBlockLabels } from './block-labels.plugin';

export default defineComponent({
    name: 'BlockRender',
    props: {
        block: {
            required: true,
            type: Object as PropType<TileModel>,
            validator(value: any): boolean {
                return 'contentType' in value && 'model' in value;
            },
        },
        isFirstBlock: {
            required: false,
            type: Boolean,
            default: false,
        },
        parent: {
            type: String,
            required: false,
            default: '',
        },
    },
    setup(props) {
        // eslint-disable-next-line vue/no-setup-props-destructure
        const contentType = props.block.contentType;
        const resolvedBlock = blockResolver.resolve(contentType);

        // eslint-disable-next-line vue/no-setup-props-destructure
        const blockLabels: IBlockLabels = props.block.model?.dictionaryLabels;
        blockLabels && provideBlockLabels(blockLabels, contentType);

        return {
            resolvedBlock,
        };
    },
});
